(() => {
  if (window.__ckCommunityInit) return;
  window.__ckCommunityInit = true;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-ck-prev],[data-ck-next]');
    if (!button) return;
    const track = button.closest('.ck-comm')?.querySelector('[data-ck-track]');
    const slide = track?.querySelector('.ck-comm__slide');
    if (!track || !slide) return;
    const step = slide.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const direction = button.hasAttribute('data-ck-next') ? 1 : -1;
    track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
})();
